import { useMemo } from "react";
import {
  useShortcutsList,
  useSaveShortcut,
  useRenameShortcut,
  useRemoveShortcut,
} from "../queries/shortcuts";
import { findShortcutByFilters } from "../lib/shortcuts";

// Normalizes the backend's `_id` to a plain `id` here, once, so the rest of
// the app (AppNav, ConversationWrapper, TasksFilterBar) works against a
// backend-agnostic {id, name, search} shape.
export function useShortcuts() {
  const { data: rawList = [] } = useShortcutsList();
  const shortcuts = useMemo(
    () => rawList.map((s) => ({ id: s._id, name: s.name, search: s.search, link: s.link })),
    [rawList],
  );

  const saveMutation = useSaveShortcut();
  const renameMutation = useRenameShortcut();
  const removeMutation = useRemoveShortcut();

  return {
    shortcuts,
    findByFilters: (search) => findShortcutByFilters(shortcuts, search),
    save: async (name, search) => {
      const res = await saveMutation.mutateAsync({ name, search });
      const doc = res?.data;
      return doc ? { id: doc._id, name: doc.name, search: doc.search, link: doc.link } : null;
    },
    rename: (id, name) => renameMutation.mutate({ id, name }),
    remove: (id) => removeMutation.mutate(id),
  };
}
